import { mappingRoles } from '~constants';

export const contractStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  EXPIRED: 'EXPIRED',
};

export const contractStatusToWord = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  EXPIRED: 'Expired',
};

export const registeredTypes = {
  SELF_REGISTERED: 'SELF_REGISTERED',
  STAFF_CREATED: 'STAFF_CREATED',
};

export const landlordStatus = {
  ONBOARDING: 'ONBOARDING',
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
  IN_CONSULTATION: 'IN_CONSULTATION',
  REJECTED: 'REJECTED',
  LOST: 'LOST',
  UNPUBLISHED: 'UNPUBLISHED',
};

export const LANDLORD_STATUS_ALL = 'ALL';
export const LANDLORD_STATUS_PENDING = 'PENDING';

export const landlordDetailTabs = {
  BASIC_INFO: 'BASIC_INFO',
  PROPERTY_RELATED: 'PROPERTY_RELATED',
  VERIFICATION: 'VERIFICATION',
  INVOICE_INFO: 'INVOICE_INFO',
  COMMISSION: 'COMMISSION',
  CONTACT: 'CONTACT',
  CONTRACT: 'CONTRACT',
  PAYMENTPLAN: 'PAYMENTPLAN',
  BOOKINGS: 'BOOKINGS',
  TOKEN: 'TOKEN',
};

export const reconciliationOption = ['BOOKING_COMPLETED', 'STUDENT_CHECK_IN', 'STUDENT_CHECK_OUT'];

export const reconciliationFrequencies = ['DAILY', 'WEEKLY', 'MONTHLY', 'QUARTERLY'];

export const invoicingFrequencies = ['MONTHLY', 'QUARTERLY', 'YEARLY'];

export const propertyStatus = {
  NEW: 'NEW',
  EDITING: 'EDITING',
  PUBLISHED: 'PUBLISHED',
  UNPUBLISHED: 'UNPUBLISHED',
};

export const allPaymentMethod = {
  STRIPE: 'STRIPE',
  VIRTUAL_CREDIT_CARD: 'VIRTUAL_CREDIT_CARD',
  BANK_TRANSFER: 'BANK_TRANSFER',
};

export const transferStatus = {
  NEW: 'NEW',
  PENDING_TRANSFER: 'PENDING_TRANSFER',
  TRANSFERRED: 'TRANSFERRED',
};

export const refundStatus = {
  NEW: 'NEW',
  PENDING_REFUND: 'PENDING_REFUND',
  REFUND_CONFIRMATION: 'REFUND_CONFIRMATION',
  REFUNDED: 'REFUNDED',
};

export const refundFromTypes = {
  ACCOMMODATION_PARTNER: 'ACCOMMODATION_PARTNER',
  STCOM: 'STCOM',
};

export const bankTransfer = {
  accountNumber: 'account_number',
  nameOfBeneficiary: 'name_of_beneficiary',
  beneficiaryAddress: 'beneficiary_address',
  bankName: 'bank_name',
  ibanNumber: 'iban_number',
  routingNumber: 'routing_number',
  sortCode: 'sort_code',
  bicOrSwiftCode: 'bic_or_swift_code',
  recipientsFullName: 'recipients_full_name',
  streetAddress: 'street_address',
  bsb: 'bsb',
  swiftCode: 'swift_code',
  accountHolderName: 'account_holder_name',
  address: 'address',
  branchName: 'branch_name',
  branchAddress: 'branch_address',
  beneficiaryBankName: 'beneficiary_bank_name',
  bankAddress: 'bank_address',
  addressOfBeneficiary: 'address_of_beneficiary',
  nameOfFrenchBank: 'name_of_french_bank',
  addressOfFrenchBank: 'address_of_french_bank',
  accountName: 'account_name',
  beneficiaryName: 'beneficiary_name',
  beneficiaryAccountNumber: 'beneficiary_account_number',
};

export const includeRoleArr = [
  mappingRoles.SUPPLY,
  mappingRoles.REGIONAL_SUPPLY_HEAD,
  mappingRoles.ADMIN,
  mappingRoles.CONTENT_MANAGER,
];

export const viewLandlordAccountOwnerRoleArr = [
  mappingRoles.SUPPLY,
  mappingRoles.REGIONAL_SUPPLY_HEAD,
  mappingRoles.ADMIN,
  mappingRoles.CONTENT_MANAGER,
];

export const editLandlordAccountOwnerRoleArr = [
  mappingRoles.SUPPLY,
  mappingRoles.REGIONAL_SUPPLY_HEAD,
  mappingRoles.ADMIN,
  mappingRoles.CONTENT_MANAGER,
];

export const LandlordRegisterType = {
  register: 'SELF_REGISTERED',
  created: 'STAFF_CREATED',
};

export const landlordSortBy = {
  CREATED_AT: 'CREATED_AT',
  NAME: 'NAME',
  PENDING_AT: 'PENDING_AT',
};

export const vettingDocumentType = {
  LANDLORD_LINK: 'LANDLORD_LINK',
  REVIEW_SITE: 'REVIEW_SITE',
  LISTING_ON_OTHER_PLATFORM: 'LISTING_ON_OTHER_PLATFORM',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
};

export const propertyBookingJourney = {
  MANUAL: 'MANUAL',
  SEMI_AUTOMATIC: 'SEMI_AUTOMATIC',
  FULL_AUTOMATIC: 'FULL_AUTOMATIC',
  INSTANT_BOOK: 'INSTANT_BOOK',
};

export const apCategoryEnum = ['STANDARD', 'KEY'];

export const apCategoryType = { STANDARD: 'STANDARD', KEY: 'KEY' };

export const PaymentPlanCategory = {
  DEPOSIT_IS_REQUIRED: 'DEPOSIT_IS_REQUIRED',
  RENT_IS_REQUIRED: 'RENT_IS_REQUIRED',
};

export const depositTransferTime = ['AFTER_CANCELLATION_DATE', 'ON_BOOKING_CONFIRMATION'];

export const rentTransferTime = [
  'AFTER_CHECK_IN_48_HOURS',
  'ON_BOOKING_CONFIRMATION',
  'AFTER_CANCELLATION_DATE',
];

export const apiTokenStatus = {
  REVOKE: 'REVOKE',
  ENABLE: 'ENABLE',
  PENDING: 'PENDING',
};

export const landlordContactType = {
  LANDLORD: 'LANDLORD',
  PROPERTY: 'PROPERTY',
  BOOKING_TEAM: 'BOOKING_TEAM',
  FINANCE_TEAM: 'FINANCE_TEAM',
};

export const landlordLinkManEnum = {
  [landlordContactType.BOOKING_TEAM]: 'bookingTeam',
  [landlordContactType.FINANCE_TEAM]: 'financeTeam',
  [landlordContactType.LANDLORD]: 'landlord',
  [landlordContactType.PROPERTY]: 'property',
};

export const companyType = {
  REAL_ESTATE_AGENCY: 'REAL_ESTATE_AGENCY',
  PROPERTY_MANAGEMENT_COMPANY: 'PROPERTY_MANAGEMENT_COMPANY',
  PRIVATE_MANAGEMENT: 'PRIVATE_MANAGEMENT',
  UNIVERSITY_OWNED_OR_MANAGED: 'UNIVERSITY_OWNED_OR_MANAGED',
  HMO: 'HMO',
  OTHER: 'OTHER',
};

export const companyTypeArr = [
  companyType.REAL_ESTATE_AGENCY,
  companyType.PROPERTY_MANAGEMENT_COMPANY,
  companyType.PRIVATE_MANAGEMENT,
  companyType.UNIVERSITY_OWNED_OR_MANAGED,
  companyType.HMO,
  companyType.OTHER,
];
